/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Tabitha Bleil
 */

import React from "react"
import {
    Element,
    Label,
    TitleSection,
    ModalTitle,
    ContentSection,
    FooterSection,
    Column,
    Button,
    Row,
    Color,
    isSmallMobileScreen,
} from "trux"
import readyToGo from "../assets/ready-to-go.svg"

export const FinishedStep = ({ loggedInUser, onBackClick, onDone }) => {
    const onLoad = () => {
        var x = document.getElementById("image-background")
        var y = document.getElementById("image")

        x.style.display = "none"
        y.style.display = "inline-block"
        console.log("loaded")
    }
    return (
        <>
            <TitleSection onBackClick={onBackClick}>
                <ModalTitle content="All set!" />
            </TitleSection>
            <ContentSection>
                <Column center span="12" className="form">
                    <Element
                        className="image-background"
                        id="image-background"
                        marginBottom="4"
                    ></Element>
                    <Element
                        tag="img"
                        width="344px"
                        height="252px"
                        src={readyToGo}
                        marginBottom={4}
                        className="image"
                        id="image"
                        onLoad={onLoad}
                    />
                    <Element className="text-contents">
                        <Label
                            color={Color.Charcoal40}
                            marginBottom={8}
                            content={`Great job, you are all set to get ${loggedInUser.first_name}'s Trace video! You can always make edits on your family page.`}
                        />
                    </Element>
                    {!isSmallMobileScreen() && (
                        <Button
                            type={Label.Type.Heading5}
                            span="12"
                            className="button"
                            onClick={onDone}
                            content={
                                <Row>
                                    <Label
                                        type={Label.Type.InnerButton}
                                        content="Finish"
                                    />
                                </Row>
                            }
                        />
                    )}
                </Column>
            </ContentSection>
            {isSmallMobileScreen() && (
                <FooterSection>
                    <Button
                        type={Label.Type.Heading5}
                        span="12"
                        className="button"
                        onClick={onDone}
                        content={
                            <Row>
                                <Label
                                    type={Label.Type.InnerButton}
                                    content="Finish"
                                />
                            </Row>
                        }
                    />
                </FooterSection>
            )}
        </>
    )
}
